var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.373 8c-.528 0-.774-.335-1.83-1.287L.304 4.633c-.407-.378-.407-.945 0-1.324a1.035 1.035 0 011.424 0l2.237 2.08c.203.19.407.19.407.19.203 0 .407-.19.407-.19L10.27.284a1.035 1.035 0 011.424 0c.407.378.407.945 0 1.323L6.203 6.713C5.124 7.823 4.9 8 4.373 8zm5.305.216c-.528 0-.623-.224-1.68-1.176-.406-.378-.406-.945 0-1.324.407-.378.91-.449 1.273-.11.204.189.407.189.407.189.203 0 .407-.19.407-.19L15.576.5A1.035 1.035 0 0117 .5c.407.378.407.945 0 1.324L11.508 6.93c-1.078 1.109-1.302 1.286-1.83 1.286z",
    fill: "#888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnread);
export default __webpack_public_path__ + "static/media/unread.08dae7f8fe1d851ea65803a56865edf6.svg";
export { ForwardRef as ReactComponent };